import { createTheme } from '@mui/material'

export const theme = createTheme({
  palette: {
    primary: { main: '#5AB71D' },
    secondary: { main: '#f5f5f5' },
    background: {
      default: '#f5f5f5',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'primary',
        },
      },
    },
  },
})
